import { render, staticRenderFns } from "./ChestXray.vue?vue&type=template&id=4990888a&scoped=true&"
import script from "./ChestXray.vue?vue&type=script&lang=js&"
export * from "./ChestXray.vue?vue&type=script&lang=js&"
import style0 from "./ChestXray.vue?vue&type=style&index=0&id=4990888a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4990888a",
  null
  
)

export default component.exports